import React from 'react';

const StoryAndCTA = () => {
  return (
    // <section className="py-16 bg-white">
    //   <div className="max-w-5xl mx-auto px-4">
    //     {/* Storytelling Component */}
    //     <div className="mb-16">
    //       <h2 className="text-3xl font-bold mb-8 text-center">The Coach's Journey</h2>
          
    //       <div className="space-y-8">
    //         <div className="bg-gray-50 p-6 rounded-xl">
    //           <h3 className="text-xl font-semibold mb-3 text-gray-900">The Challenge</h3>
    //           <p className="text-gray-700 mb-4">
    //             Meet Sarah, a passionate health coach who was working 60+ hours a week. Despite her expertise and dedication, 
    //             she spent over 20 hours on administrative tasks—scheduling, payment tracking, client follow-ups, and creating 
    //             personalized plans. She was burning out fast and knew something had to change.
    //           </p>
    //           <div className="flex items-center">
    //             <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center text-red-600 mr-3">
    //               <span className="text-xl">😓</span>
    //             </div>
    //             <p className="italic text-gray-600">
    //               "I was spending more time on paperwork than with my clients. It wasn't sustainable."
    //             </p>
    //           </div>
    //         </div>
            
    //         <div className="bg-gray-50 p-6 rounded-xl">
    //           <h3 className="text-xl font-semibold mb-3 text-gray-900">The Turning Point</h3>
    //           <p className="text-gray-700 mb-4">
    //             Sarah discovered our platform and was initially skeptical. But after her 14-day trial, she realized how much 
    //             time she could save. The automated scheduling eliminated back-and-forth emails. Payment processing happened 
    //             seamlessly. Client communication was organized in one place.
    //           </p>
    //           <div className="flex items-center">
    //             <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center text-yellow-600 mr-3">
    //               <span className="text-xl">💡</span>
    //             </div>
    //             <p className="italic text-gray-600">
    //               "Within a week, I could see this was going to change everything about how I run my practice."
    //             </p>
    //           </div>
    //         </div>
            
    //         <div className="bg-gray-50 p-6 rounded-xl">
    //           <h3 className="text-xl font-semibold mb-3 text-gray-900">The Transformation</h3>
    //           <p className="text-gray-700 mb-4">
    //             Three months later, Sarah had reclaimed 15+ hours per week. Her client retention increased by 35% 
    //             because of the seamless experience and automated check-ins. With the time saved, she launched a new 
    //             group program that increased her revenue by 40%.
    //           </p>
    //           <div className="flex items-center">
    //             <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center text-green-600 mr-3">
    //               <span className="text-xl">🎉</span>
    //             </div>
    //             <p className="italic text-gray-600">
    //               "I've found the perfect balance. My business is thriving, and I'm no longer working evenings and weekends."
    //             </p>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
        
    //     {/* Final CTA Section */}
    //     <div className="bg-emerald-50 rounded-2xl p-8 md:p-12 text-center">
    //       <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready for Your Success Story?</h2>
    //       <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto">
    //         Join Sarah and thousands of other coaches who have transformed their practices, reclaimed their time, 
    //         and grown their businesses with our all-in-one platform.
    //       </p>
          
    //       <div className="mb-8">
    //         <div className="flex items-center justify-center space-x-2 mb-2">
    //           <span className="text-yellow-400 text-2xl">★★★★★</span>
    //           <span className="font-bold">4.9/5</span>
    //         </div>
    //         <p className="text-gray-600">Average rating from 200+ coaches</p>
    //       </div>
          
    //       <a 
    //         href="https://calendly.com/hyphii" 
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         className="inline-block bg-black text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-emerald-600 transition duration-300 shadow-lg"
    //       >
    //         Schedule Your Free Demo
    //       </a>
          
    //       <p className="mt-4 text-gray-600">
    //         No credit card required • Free 14-day trial • 30-day money-back guarantee
    //       </p>
          
    //       <div className="mt-8 flex justify-center">
    //         <div className="inline-flex rounded-lg border border-gray-200 overflow-hidden">
    //           <div className="px-4 py-2 bg-white font-medium text-black">Start Today</div>
    //           <div className="px-4 py-2 bg-emerald-500 text-white">Save 30% on Admin Time</div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
<>
            <section className="py-16 bg-white-50">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-6">Ready to transform your coaching business?</h2>
            <p className="text-lg text-gray-700 mb-8">Join the growing community of coaches who are saving time, increasing client retention, and growing their businesses with our AI-powered platform.</p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a 
                href="https://calendly.com/hyphii" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto bg-black text-white px-8 py-4 rounded-xl hover:bg-emerald-600 transition duration-300 font-medium flex items-center justify-center"
              >
                Schedule Demo
              </a>
              <a 
                href="#features"
                className="w-full sm:w-auto bg-white text-gray-900 border border-gray-200 px-8 py-4 rounded-xl hover:bg-gray-50 transition duration-300 font-medium flex items-center justify-center"
              >
                Learn More
              </a>
            </div>
          </div>
        </section>

                <section className="py-16 bg-gray-50">
          <div className="max-w-6xl mx-auto px-4">
            <div className="grid md:grid-cols-3 gap-6">
              <div className="p-6 border border-gray-100 rounded-xl hover:shadow-md transition duration-300">
                <h3 className="text-xl font-semibold mb-3">Targeted to Solopreneurs</h3>
                <p className="text-gray-600">Built exclusively for coaching and wellness professionals with industry-specific templates and workflows.</p>
              </div>
              <div className="p-6 border border-gray-100 rounded-xl hover:shadow-md transition duration-300">
                <h3 className="text-xl font-semibold mb-3">True AI Differentiation</h3>
                <p className="text-gray-600">Not just automations—our platform learns user behavior and client preferences for personalized recommendations.</p>
              </div>
              <div className="p-6 border border-gray-100 rounded-xl hover:shadow-md transition duration-300">
                <h3 className="text-xl font-semibold mb-3">Frictionless Experience</h3>
                <p className="text-gray-600">Minimal setup with calendar, payment, and email integrations for instant improvement in efficiency.</p>
              </div>
            </div>
          </div>
        </section>
        </>
  );
};

export default StoryAndCTA;